export default __webpack_public_path__ + "static/media/folder-add.d41a0e4f.svg";